export default "__VITE_ASSET__BXoY956c__"